import { useEffect } from "react";

export function useDocumentTitle(title: string | null | undefined): void {
	useEffect(() => {
		if (title) {
			document.title = `${title} — clearvoid`;
		}
		return () => {
			document.title = "clearvoid";
		};
	}, [title]);
}
